import {
  FRENCH,
  GERMAN,
  ENGLISH,
  ENGLISH_USA,
  ITALIAN,
  SPANISH,
  POLISH,
  PORTUGUESE,
  SWEDISH,
} from 'config/types/language';

const LearnLanguages = {
  DAN: 'DAN',
  DEU: 'DEU',
  ENG: 'ENG',
  FRA: 'FRA',
  IND: 'IND',
  ITA: 'ITA',
  NLD: 'NLD',
  NOR: 'NOR',
  POL: 'POL',
  POR: 'POR',
  QMS: 'QMS',
  RUS: 'RUS',
  SPA: 'SPA',
  SWE: 'SWE',
  TUR: 'TUR',
};

const {
  DAN,
  DEU,
  ENG,
  FRA,
  IND,
  ITA,
  NLD,
  NOR,
  POL,
  POR,
  QMS,
  RUS,
  SPA,
  SWE,
  TUR,
} = LearnLanguages;

const englishMap = {
  danish: DAN,
  german: DEU,
  french: FRA,
  indonesian: IND,
  italian: ITA,
  dutch: NLD,
  norwegian: NOR,
  polish: POL,
  portuguese: POR,
  'mexican-spanish': QMS,
  russian: RUS,
  spanish: SPA,
  swedish: SWE,
  turkish: TUR,
};

// Commented tags do not exist currently
const tagToLearnLanguageMap = {
  [ENGLISH]: englishMap,
  [ENGLISH_USA]: englishMap,
  [FRENCH]: {
    danois: DAN,
    allemand: DEU,
    anglais: ENG,
    indonesien: IND,
    italien: ITA,
    neerlandais: NLD,
    norvegien: NOR,
    // polonais: POL,
    portugais: POR,
    russe: RUS,
    espagnol: SPA,
    suedois: SWE,
    turc: TUR,
  },
  [GERMAN]: {
    danisch: DAN,
    englisch: ENG,
    franzosisch: FRA,
    indonesisch: IND,
    italienisch: ITA,
    niederlandisch: NLD,
    norwegisch: NOR,
    polnisch: POL,
    portugiesisch: POR,
    russisch: RUS,
    spanisch: SPA,
    schwedisch: SWE,
    turkisch: TUR,
  },
  [ITALIAN]: {
    // danese: DAN,
    tedesco: DEU,
    inglese: ENG,
    francese: FRA,
    // indonesiano: IND,
    olandese: NLD,
    // norvegese: NOR,
    // polacco: POL,
    portoghese: POR,
    russo: RUS,
    spagnolo: SPA,
    svedese: SWE,
    turco: TUR,
  },
  [SPANISH]: {
    danes: DAN,
    ingles: ENG,
    aleman: DEU,
    frances: FRA,
    // indonesio: IND,
    italiano: ITA,
    // holandes: NLD,
    noruego: NOR,
    // polaco: POL,
    portugues: POR,
    ruso: RUS,
    sueco: SWE,
    turco: TUR,
  },
  [POLISH]: {
    // dunski: DAN,
    angielski: ENG,
    niemiecki: DEU,
    // francuski: FRA,
    // indonezyjski: IND,
    // italski: ITA,
    // holenderski: NLD,
    norweski: NOR,
    // portugalski: POR,
    // ruski: RUS,
    // hiszpanski: SPA,
    // szwedzki: SWE,
    // turecki: TUR,
  },
  [PORTUGUESE]: {
    // dinamarquês: DAN,
    // aprender-ingles also exists
    ingles: ENG,
    // aprender-alemao and alemanha also exists
    alemao: DEU,
    // aprender-frances also exists
    frances: FRA,
    // indonesio: IND,
    // aprender-italiano and italia also exist
    italiano: ITA,
    // holanda also exists
    holandes: NLD,
    // noruegues: NOR,
    // polones: POL,
    russo: RUS,
    // aprender-espanhol also exists
    espanhol: SPA,
    // suecia also exists
    sueco: SWE,
    turco: TUR,
  },
  [SWEDISH]: {
    // danska: DAN,
    // engelska: ENG,
    // tyska: DEU,
    franska: FRA,
    // indonesiska: IND,
    // italienska: ITA,
    // hollandska: NLD,
    // norska: NOR,
    // polska: POL,
    // portugisiska: POR,
    // ryska: RUS,
    spanska: SPA,
    turkiska: TUR,
  },
};

const tagToLearnLanguage = (edition, tagSlug) => tagToLearnLanguageMap[edition][tagSlug];
export const learnLanguageToTag = (edition, learnLanguageTarget) => Object
  .entries(tagToLearnLanguageMap[edition])
  .find(([_tag, learnLanguage]) => learnLanguageTarget === learnLanguage)[0];

export default tagToLearnLanguage;
